// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import toast from '@/plugins/toast';
import localStorage, { LocalStorageKeys } from '@/utils/local_storage';
import utils from '@/utils/utils.js';
import { userVip } from '@/utils/api/apis.js'
import Dialog from '@/utils/dialog';
import store from '@/store'  // 确保引入 store
import errorLog from '@/utils/error-log'

// 添加设备检测函数
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// 创建 Vue 实例前初始化通用数据
store.dispatch('common/fetchCommonData').catch(error => {
  console.error('Failed to fetch common data:', error);
});

// 添加倒计时相关常量和工具函数
const THREE_DAYS = 3 * 24 * 60 * 60 * 1000; // 3天的毫秒数

// 格式化时间的工具函数
const formatCountdown = (countdown) => {
  const { days, hours, minutes, seconds } = countdown;
  return `${days}天${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

// 获取倒计时数据
const getCountdownData = (targetDate) => {
  const now = new Date().getTime();
  const diff = targetDate - now;

  if (diff <= 0) {
    // 重置为新的3天
    const newTarget = now + THREE_DAYS;
    localStorage.set(LocalStorageKeys.COUNTDOWN_KEY, newTarget.toString());
    return getCountdownData(newTarget);
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
    targetDate
  };
};

// 创建全局倒计时服务
const countdownService = {
  targetDate: null,
  subscribers: new Set(),

  init() {
    // 从localStorage获取目标时间，如果没有则创建新的
    let savedTarget = localStorage.get(LocalStorageKeys.COUNTDOWN_KEY);
    if (!savedTarget) {
      savedTarget = (Date.now() + THREE_DAYS).toString();
      localStorage.set(LocalStorageKeys.COUNTDOWN_KEY, savedTarget);
    }
    this.targetDate = parseInt(savedTarget);

    // 启动定时器
    setInterval(() => {
      const countdownData = getCountdownData(this.targetDate);
      this.targetDate = countdownData.targetDate;
      this.notifySubscribers(countdownData);
    }, 1000);
  },

  subscribe(callback) {
    this.subscribers.add(callback);
    // 立即返回当前倒计时数据
    callback(getCountdownData(this.targetDate));
    // 返回取消订阅函数
    return () => this.subscribers.delete(callback);
  },

  notifySubscribers(data) {
    this.subscribers.forEach(callback => callback(data));
  }
};

// 初始化倒计时服务
countdownService.init();

Vue.use(toast)
Vue.use(utils);
Vue.use(errorLog);
Vue.config.productionTip = false
Vue.prototype.$localStorage = localStorage;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$countdownService = countdownService;
Vue.prototype.$formatCountdown = formatCountdown;

// 全局前置守卫
router.beforeEach(async (to, from, next) =>  {
  if (isMobile() && to.path !== '/download') {
    next('/download');
  } else {
    next();
  }
  if (!isMobile()) {
    console.log(to.path);
    const userInfo = localStorage.get(LocalStorageKeys.USER_INFO);
    if (!userInfo && to.path !== '/login') {
      next('/login');
    } else if (userInfo && to.path !== '/') {
      next('/');
    } else {
      next(); // 放行
    }
  }
  // 检查是否有 token
  const userInfo = localStorage.get(LocalStorageKeys.USER_INFO);
  if (!userInfo && to.path !== '/login') {
    next('/login');
  } else {
    next(); // 放行
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js